import { apiClient } from './api';

function unwrapData<T>(
  res: { success: boolean; data?: T; message?: string; error?: string },
  fallbackMsg: string,
): T {
  if (!res.success || res.data === undefined) {
    throw new Error(res.message || res.error || fallbackMsg);
  }
  return res.data;
}

export const carouselService = {
  async list(): Promise<Record<string, unknown>[]> {
    const res = await apiClient.get<Record<string, unknown>[]>('/admin/carousels');
    return unwrapData(res, 'خطا در دریافت کروسل‌ها');
  },
  async create(data: Record<string, unknown>): Promise<Record<string, unknown>> {
    const res = await apiClient.post<Record<string, unknown>>('/admin/carousels', data);
    return unwrapData(res, 'ایجاد کروسل ناموفق بود');
  },
  async update(id: string, data: Record<string, unknown>): Promise<Record<string, unknown>> {
    const res = await apiClient.put<Record<string, unknown>>(`/admin/carousels/${id}`, data);
    return unwrapData(res, 'ویرایش کروسل ناموفق بود');
  },
  async remove(id: string): Promise<void> {
    const res = await apiClient.delete(`/admin/carousels/${id}`);
    if (!res.success) throw new Error(res.message || 'حذف کروسل ناموفق بود');
  },
};
